<footer class="footer">
  <div class="footer-main">
    <!-- Azienda Section -->
    <div class="azienda-section">
      <h3 class="section-title">{{ 'dottnet.footer.companySection.title' | translate }}</h3>
      <p class="azienda-description" [innerHTML]="'dottnet.footer.companySection.description' | translate"></p>
      <div class="read-more-wrapper">
        <a routerLink="/chi-siamo" class="read-more">{{ 'dottnet.footer.readMore' | translate }} &gt;</a>
        <div class="read-more-line"></div>
      </div>
    </div>

    <!-- Company Info Section -->
    <div class="company-info-section">
      <h3 class="section-title">{{ 'dottnet.footer.contatti' | translate }}</h3>
      <div class="contact-info">
        <div class="company-name">{{ 'dottnet.footer.contacts.companyName' | translate }}</div>
        <div class="contact-item">
          <div class="icon">📍</div>
          <div>{{ 'dottnet.footer.contacts.address' | translate }}</div>
        </div>
        <div class="contact-item">
          <div class="icon">✉️</div>
          <a href="mailto:redazione@merqurio.it">redazione&#64;merqurio.it</a>
        </div>
        <div class="contact-item">
          <div class="icon">📞</div>
          <div>{{ 'dottnet.footer.contacts.phone' | translate }}</div>
        </div>
      </div>
    </div>

    <!-- Collegati Section -->
    <div class="collegati-section">
      <h3 class="section-title">{{ 'dottnet.footer.followus' | translate }}</h3>
      <div class="social-icons">
        <a [href]="facebookLink()" target="_blank" rel="noopener noreferrer" class="social-icon">
          <fa-icon [icon]="facebook"></fa-icon>
        </a>
        <a [href]="twitterLink()" target="_blank" rel="noopener noreferrer" class="social-icon">
          <fa-icon [icon]="x"></fa-icon>
        </a>
        <a [href]="instagramLink()" target="_blank" rel="noopener noreferrer" class="social-icon">
          <fa-icon [icon]="instagram"></fa-icon>
        </a>
        <a [href]="linkedinLink()" target="_blank" rel="noopener noreferrer" class="social-icon">
          <fa-icon [icon]="linkedin"></fa-icon>
        </a>
        <a href="https://www.tiktok.com/@dottnet.it" target="_blank" rel="noopener noreferrer" class="social-icon">
          <fa-icon [icon]="tiktok"></fa-icon>
        </a>
      </div>
    </div>

    <!-- Informati Section -->
    <div class="informati-section">
      <ul class="info-links">
        <li><a routerLink="/condizioni-utilizzo">{{ 'dottnet.footer.condizioni' | translate }}</a></li>
        <li><a routerLink="/privacy">{{ 'dottnet.footer.privacy' | translate }}</a></li>
        <li><a routerLink="/informativa-cookies">{{ 'dottnet.footer.cookies' | translate }}</a></li>
        <li><a routerLink="/redazione">{{ 'dottnet.footer.redazione' | translate }}</a></li>
        <div class="contact-item">
          <div>{{ 'dottnet.footer.contacts.vatLabel' | translate }} 05877761212</div>
        </div>
      </ul>
    </div>

  </div>

</footer>
